<template>
  <div>
    <div class="menu-item-option-editor__title">
      <w-input
        :maxLength="40"
        class="flex-grow mr-4"
        input-class="focus:border-white hover:border-white text-white"
        placeholder="請輸入選項名稱"
        shape="light"
        v-model="name"
      />
      <div class="flex-grow-0 flex-shrink-0">
        <w-button class="mr-7" type="icon" @click="$emit('remove-option', option)">
          <i class="icon-trash text-white" />
        </w-button>
        <w-button type="icon" @click="$emit('show', false)">
          <i class="icon-up-chevron text-white" />
        </w-button>
      </div>
    </div>
    <div class="border-b border-blue-100 flex flex-col py-2">
      <section class="border-b border-blue-100 flex items-baseline mt-2 pb-2">
        <label class="flex-shrink-0 px-4 text-gray-500 w-20">
          說明
        </label>
        <w-input
          :maxLength="40"
          class="flex-grow px-4"
          placeholder="請輸入選項說明"
          shape="clear"
          show-count
          v-model="note"
        />
      </section>
      <section class="flex items-baseline mt-4 px-4">
        <label class="flex-shrink-0 text-gray-500 w-20">
          可選項目
        </label>
        <div class="flex flex-col flex-grow overflow-x-hidden">
          <div
            v-for="(item, itemViewIndex) in items"
            :key="`option-${optionIndex}-item-${item.index}`"
            class="flex items-center justify-between ml-4 my-2 truncate"
          >
            <span class="truncate">{{ item.name }}</span>
            <div class="flex-grow-0 flex-shrink-0">
              <span class="mr-2 text-gray-300">
                {{ item.price | commaFormat | priceFormat }}
              </span>
              <w-button
                type="icon"
                @click="onRemoveOriginItem(itemViewIndex, item.index)"
              >
                <i class="icon-trash text-gray-300" />
              </w-button>
            </div>
          </div>
          <div
            v-for="(item, newItemIndex) in newItems"
            :key="`add-option-item-${item.index}`"
            class="flex items-center justify-between mb-2 ml-1"
          >
            <w-input
              :ref="`new-option-${optionIndex}-item-name-${item.index}`"
              :maxLength="40"
              class="flex-grow mr-4"
              placeholder="請輸入可選項目名稱"
              shape="clear"
              v-model="item.name"
              @keydown.down.native.stop.prevent="
                onFocusNext($event, newItemIndex, `new-option-${optionIndex}-item-name`)
              "
              @keypress.enter.native.stop.prevent="
                onCheckAndAddNewItem($event, newItemIndex, `new-option-${optionIndex}-item-name`)
              "
              @keydown.right.native.stop.prevent="
                onFocus($event, `new-option-${optionIndex}-item-price-${item.index}`)
              "
              @keydown.up.native.stop.prevent="
                onFocusPre($event, newItemIndex, `new-option-${optionIndex}-item-name`)
              "
            />
            <div class="flex items-center flex-shrink-0">
              <span class="mb-[1px] text-black">$</span>
              <w-input
                :ref="`new-option-${optionIndex}-item-price-${item.index}`"
                class="w-20"
                placeholder="0"
                shape="clear"
                type="number"
                v-model="item.price"
                @keydown.down.native.stop.prevent="
                  onFocusNext($event, newItemIndex, `new-option-${optionIndex}-item-price`)
                "
                @keypress.enter.native.stop.prevent="
                  onCheckAndAddNewItem($event, newItemIndex, `new-option-${optionIndex}-item-price`)
                "
                @keydown.left.native.stop.prevent="
                  onFocus($event, `new-option-${optionIndex}-item-name-${item.index}`)
                "
                @keydown.up.native.stop.prevent="
                  onFocusPre($event, newItemIndex, `new-option-${optionIndex}-item-price`)
                "
              />
            </div>
            <w-button
              class="hover:text-red-500 text-gray-300"
              type="icon"
              @click="onRemoveItem(newItemIndex)"
            >
              <i class="icon-trash" />
            </w-button>
          </div>
          <div>
            <w-button
              v-if="!hasEmptyItems"
              class="flex-grow-0 flex-shrink-0 my-2"
              color-type="secondary"
              size="sm"
              type="link"
              @click="onAddNewItem"
            >
              <i class="icon-plus mr-2" />
              <span>新增可選項目</span>
            </w-button>
          </div>
        </div>
      </section>
    </div>
    <div class="flex flex-col">
      <section class="flex flex-wrap items-center px-4 py-2">
        <div class="flex-shrink-0 mr-4">
          <span class="text-gray-500">
            最少選擇幾個項目？
          </span>
        </div>
        <w-counter
          :max="minMax"
          :min="0"
          v-model="min"
        />
      </section>
      <section class="flex flex-wrap items-center px-4 py-2">
        <div class="flex-shrink-0 mr-4">
          <span class="text-gray-500">
            最多選擇幾個項目？
          </span>
        </div>
        <w-counter
          :max="totalItemsLength"
          :min="0"
          v-model="max"
        />
      </section>
    </div>
    <div v-if="isDirty" class="flex items-center justify-end my-2 px-4">
      <w-button
        class="mr-6"
        size="sm"
        type="link"
        @click="onResetDatum()"
      >
        取消
      </w-button>
      <w-button
        :disabled="disableConfirmBtn"
        size="sm"
        @click="onSaveOptionWithItems()"
      >
        確定
      </w-button>
    </div>
  </div>
</template>

<script>
import MenuItemOptionEditor from './MenuItemOptionEditor';

export default MenuItemOptionEditor;
</script>

<style lang="scss" scoped>
@import 'MenuItemOptionEditor';
</style>
